<template>
<div class="conversation-row" @click.prevent="onClicked">
  <user-image :user="other" class="is-40x40" />
  <div class="text-content">
    <div class="header">
      <strong>{{ name }}</strong>
      <span>{{ date }}</span>
    </div>
    <p :class="{ 'is-unread': isUnread }">{{ preview }}</p>
  </div>
</div>
</template>

<script>
import Moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import UserImage from '@/components/general/user-image'

export default {
  components: { UserImage },
  props: {
    conversation: {
      type: Object,
      required: true
    }
  },
  methods: {
    onClicked () {
      this.$emit('click')
    }
  },
  computed: {
    ...mapState('users', [
      'user'
    ]),
    ...mapGetters('conversations', [
      'otherUser'
    ]),
    other () {
      return {
        id: this.conversation.otherId,
        firstName: this.conversation.otherFirstName,
        lastName: this.conversation.otherLastName,
        profilePictureUrl: this.conversation.imageUrl
      }
    },
    name () {
      const user = this.other || {}
      return `${user.firstName} ${user.lastName}`
    },
    preview () {
      return this.conversation.messageContent
    },
    date () {
      const moment = Moment(this.conversation.date)
      return moment.format('DD MMM')
    },
    isUnread () {
      return this.conversation.status === 'unread' || false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.conversation-row {
  padding: 1rem;
  display: flex;
  background-color: white;
}

.text-content {
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 0;
  width: 100%;
  overflow: hidden;

  .header {
    display: flex;
    justify-content: space-between;

    span {
      color: #888;
    }
  }

  p {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: calc(100% - 1rem);
    color: #888;
  }
}

p.is-unread {
  font-weight: bold;
  color: $black;
}
</style>



// WEBPACK FOOTER //
// src/components/messaging/conversation-row.vue